import { Stack } from '@mui/joy';

import { BomPartNumber } from 'bom/elements';
import { IBomPart } from 'bom/types';
import {
  AttributePartType,
  SelectAttributePartButton,
} from 'quotes/components/AttributePartDetails';
import { QuotePartRecordType } from 'quotes/enums';
import { QuotePartHelper } from 'quotes/helpers';
import { IAttributePartPayload, IQuotePart } from 'quotes/types';

interface IProps {
  quotePart: IQuotePart;
  isSelectPartAllowed: boolean;
  onPartNumberClick?: (quotePart: IQuotePart) => void;
  onAttachParts?: (parts: IAttributePartPayload[]) => Promise<{ newRows: IQuotePart[] }>;
}

export const PartTypeDiscountContent = ({
  quotePart,
  onPartNumberClick,
  isSelectPartAllowed,
  onAttachParts,
}: IProps) => {
  const isPartDiscount = quotePart.recordType === QuotePartRecordType.PART_DISCOUNT;

  const onPartClick =
    isPartDiscount && onPartNumberClick
      ? (bomPart: IBomPart) => onPartNumberClick(bomPart as IQuotePart)
      : undefined;

  const BomPartNumberElement = (
    <BomPartNumber
      bomPart={quotePart}
      onPartClick={onPartClick}
      isDeleted={Boolean(quotePart?.deleted && !quotePart?.omitted)}
      getDisplayedPartNumber={(bomPart) =>
        QuotePartHelper.getDisplayedPartNumber(bomPart as IQuotePart)
      }
    />
  );

  if (isPartDiscount) {
    return BomPartNumberElement;
  }

  return (
    <Stack spacing={0}>
      {BomPartNumberElement}

      {isSelectPartAllowed && (
        <SelectAttributePartButton
          type={AttributePartType.PRICING_GROUP}
          selectedPart={quotePart}
          onAttachParts={onAttachParts}
        />
      )}
    </Stack>
  );
};
